// extracted by mini-css-extract-plugin
export default {"style":"FormulaireAxe_style__azwsI","input":"FormulaireAxe_input__u7vhr","borderr":"FormulaireAxe_borderr__6A-RI","styleTitle":"FormulaireAxe_styleTitle__9Hy5V"};